<template>
  <div class="description-header">
    <h1 itemprop="name">{{ jewel.title }}</h1>
    <p
      class="materials"
      itemprop="material"
    >
      {{ jewel.material }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'CatalogJewelArticleDescriptionHeader',
  props: ['jewel'],
  data: function () {
    return {}
  }
}
</script>

<style scoped lang="scss">
  .description-header {
    margin-bottom: 1em;
    & > h1 {
      margin-bottom: 0.5em;
    }
    & > .materials {
      font-family: "Gotham Pro Regular", $font-stack;
      text-transform: uppercase;
      font-size: 1.25em;
      margin-bottom: 0;
      line-height: normal;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/catalog-jewel-article/catalog-jewel-article-description/CatalogJewelArticleDescriptionHeader.vue